import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
// import { useTranslation } from 'react-i18next'

import { fetch_all } from '../../lib/server_helper';
import { loginAtom } from '../../lib/auth';

import {
  StyledSelect
} from '../../components/interface';

import { EmailTemplate } from '../../models/EmailTemplate';

type Props = {
  value: string;
  onChange: (x:string) => void;
  label?: string;
};

export const PickersEmailPicker: FunctionComponent<Props> = ({value, onChange, label}) => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  // const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  const [templates, setTemplates] = useState<EmailTemplate[]>([]);
  const [loader, setLoader] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("internal_key ASC");

  useEffect(() => {
    onSearch('');
  }, [page, order]);

  const onSearch = (s: string) => {
    // console.log(filters);
    setLoader(true);
    fetch_all<EmailTemplate>('/nl/v3/objects/fetch_all', {
      object: 'v2_email_template',
      fields: ['id', 'internal_key'],
      per_page: 1000,
      page: page,
      order: order,
      filter: {
        search: '',
        advanced: {
          system: 1
        }
      }
    }, (obs, complete_data) => {
      setTemplates(obs.filter(fff => true));
      setLoader(false);
    }, (z) => {
      
    }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
  };

  return (<>
    <StyledSelect
      label={label || "Email Keys"}
      value={value}
      id='email_keys'
      onChange={(v) => {
        onChange(v);
      }}
      list={templates.map(template => ({id: (template.internal_key || '').toString(), name: template.internal_key || ''}))}
    />
  </>);
}




